import React from 'react';
import ArrowDropDown from '@material-ui/icons/ArrowDropDown';

export default function DropdownIndicator(props) {
    const { getStyles, innerProps } = props; // eslint-disable-line react/prop-types
    return (
        <div
            {...innerProps}
            style={getStyles('dropdownIndicator', props)}
        >
            <ArrowDropDown />
        </div>
    );
}
